"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var hooks_1 = require("../../../../hooks");
var utils_1 = require("../../../../utils/utils");
var Button_1 = __importDefault(require("../../../Button/Button"));
var DeleteComps_1 = require("../DeleteComps");
var DropDownMenu_1 = __importDefault(require("../DropDownMenu"));
var OdmitnutiWrap = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var $isModal = _a.$isModal;
    return $isModal && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-top: 0.5rem;\n      padding: 1rem;\n      background: #e5ebf0;\n\n      p {\n        margin-bottom: 0;\n      }\n    "], ["\n      margin-top: 0.5rem;\n      padding: 1rem;\n      background: #e5ebf0;\n\n      p {\n        margin-bottom: 0;\n      }\n    "])));
});
var OdmitnutiHeader = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 15px;\n  font-weight: bold;\n  color: #000000;\n  margin-bottom: 5px;\n"], ["\n  font-size: 15px;\n  font-weight: bold;\n  color: #000000;\n  margin-bottom: 5px;\n"])));
var OdmitnutiSubHeader = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 13px;\n  font-weight: bold;\n  color: #000000;\n  margin-bottom: 5px;\n"], ["\n  font-size: 13px;\n  font-weight: bold;\n  color: #000000;\n  margin-bottom: 5px;\n"])));
var OznaceniDiv = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  word-wrap: break-word;\n  font-size: 15px;\n"], ["\n  word-wrap: break-word;\n  font-size: 15px;\n"])));
var DetailOdmitnutiUkonu = function (_a) {
    var _b;
    var odmitnuti = _a.odmitnuti, isModal = _a.isModal, handleEdit = _a.handleEdit, typyOdmitnuti = _a.typyOdmitnuti, handleSmazat = _a.handleSmazat;
    var showDeleteDialog = hooks_1.useBoolean(false);
    var ref = react_1.useRef(null);
    react_1.useEffect(function () {
        if (ref.current && showDeleteDialog.value) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [showDeleteDialog.value]);
    var getDeleteMessage = function () {
        var _a;
        return (react_1.default.createElement("div", null,
            "Odm\u00EDtnut\u00ED \u00FAkonu ",
            react_1.default.createElement("strong", null, (_a = (typyOdmitnuti || []).find(function (t) { return t.id === (odmitnuti === null || odmitnuti === void 0 ? void 0 : odmitnuti.idTypOdmitnuti); })) === null || _a === void 0 ? void 0 : _a.nazev),
            " ze dne ",
            utils_1.formatDate(odmitnuti.datum),
            " bylo \u00FAsp\u011B\u0161n\u011B smaz\u00E1no."));
    };
    return (react_1.default.createElement(OdmitnutiWrap, { "$isModal": isModal, ref: ref },
        isModal && react_1.default.createElement(DropDownMenu_1.default, { handleEdit: handleEdit, handleDelete: showDeleteDialog.setTrue, id: odmitnuti.id }),
        react_1.default.createElement(OdmitnutiHeader, null, (_b = (typyOdmitnuti || []).find(function (t) { return t.id === (odmitnuti === null || odmitnuti === void 0 ? void 0 : odmitnuti.idTypOdmitnuti); })) === null || _b === void 0 ? void 0 : _b.nazev),
        react_1.default.createElement(OdmitnutiSubHeader, null,
            "Datum odm\u00EDtnut\u00ED: ",
            utils_1.formatDate(odmitnuti.datum)),
        react_1.default.createElement(OznaceniDiv, null, odmitnuti.oznaceniUkon),
        !isModal && react_1.default.createElement("br", null),
        showDeleteDialog.value && (react_1.default.createElement(DeleteComps_1.DeleteDialog, { id: "deleteDialog" + odmitnuti.id },
            react_1.default.createElement(DeleteComps_1.DeleteDialogText, null, "Opravdu chcete toto odm\u00EDtnut\u00ED \u00FAkonu smazat?"),
            react_1.default.createElement(DeleteComps_1.DeleteButtonsWrap, null,
                react_1.default.createElement(Button_1.default, { type: "button", primary: false, onClick: showDeleteDialog.setFalse, name: "Zachovat" }, "NE, ZACHOVAT"),
                react_1.default.createElement(Button_1.default, { type: "button", primary: true, onClick: function () { return handleSmazat(odmitnuti.id, getDeleteMessage()); }, name: "Smazat" }, "ANO, SMAZAT"))))));
};
DetailOdmitnutiUkonu.defaultProps = {
    isModal: false,
    typyOdmitnuti: undefined,
};
exports.default = DetailOdmitnutiUkonu;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
